export default {
  AdditionalCharge: "AdditionalCharge",
  AddAdditionalCharge: "AddAdditionalCharge",
  editAdditionalCharge: "EditAdditionalCharge",
};
